<template>
  <div class="">
    <div class="neiye_banner">
      <BANNER></BANNER>
    </div>
    <div class="main">
      <div class="container">
        <div class="location">
          <router-link to="/">网站首页</router-link>
          <router-link to="/ylts/home">&nbsp;&gt;&nbsp;医疗特色</router-link>
          <router-link to="/ylts/mingyi">&nbsp;&gt;&nbsp;盛京名医</router-link>
        </div>
        <div class="tv_main clearfix">
          <div class="sjhy_main_left fl">
            <SLIDE></SLIDE>
          </div>
          <div class="sjmy_main_right fr">
            <div
              id="collapse1"
              class="panel-collapse chen_collapse collapse in"
              role="tabpane1"
              aria-labelledby="heading1"
              aria-expanded="true"
              style=""
            >
              <div class="panel-body">
                <div class="sjmy_main_list">
                  <ul class="ksjs">
                    <!--  @click="dialogVisible = true" -->
                    <li v-for="(item, m) in list" :key="m">
                      <span class="ksjs_name" @click="getdoctorList(item)">{{
                        item.name
                      }}</span>
                      <span class="ksjs_list">
                        <b
                          v-for="(detail, n) in item.children"
                          :key="n"
                          @click="getdoctorList(detail)"
                        >
                          <a href="javascript:void(0);">{{ detail.name }}</a>
                        </b>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="45%">
      <div class="tanchu clearfix famous_doctor">
        <div
          class="modal fade in"
          id="myModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="ysModalLabel"
          aria-hidden="false"
          style="display: block; height: 550px; overflow-y: scroll"
        >
          <div class="modal-backdrop fade in"></div>

          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  <span class="close_tck" @click="dialogVisible = false">×</span
                  ><span class="sr-only">Close</span>
                </button>

                <h4 class="modal-title" id="ysModalLabel">
                  {{ dialogKsname }}
                </h4>
              </div>

              <div class="modal-body table-responsive" id="ibox">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="w50">姓名</th>

                      <th class="w50">职称</th>

                      <th>专业特长</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      style="cursor: pointer"
                      v-for="(item, index) in doctorListData"
                      :key="index"
                      @click="godoctor(item.id)"
                    >
                      <td>
                        <span>{{ item.name }}</span>
                      </td>

                      <td>
                        <span v-html="item.zhicheng"></span>
                      </td>

                      <td>
                        <span
                          v-html="item.description"
                          class="description"
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import service from "../../service/ylts";
import BANNER from "../../components/banner/ylts";
export default {
  name: "ksjs",
  props: {},
  data() {
    return {
      list: [],
      dialogVisible: false,
      doctorListData: [],
      dialogKsname: "",
    };
  },
  components: { BANNER },
  methods: {
    gomingyi(item) {
      let articleId = item.id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/kslist/${articleId}`,
      });
      window.open(href, "_self");
    },
    getKsList(id) {
      service.getKsTree({}, (res) => {
        let list = [];
        res.children.map((item) => {
          if (item.id == id) {
            this.list = item.children;
          }
        });
      });
    },
    getdoctorList(e) {
      this.dialogKsname = e.name;
      this.dialogVisible = true;
      let parmes = {
        pageIndex: 1,
        pageSize: 200,
        departId: e.id,
      };
      service.getArcDocList(parmes, (res) => {
        if (res.length) {
          res.map((item) => {
            item.description = item.description.replace(/<.*?>/gi, "").trim();
            //   .replaceAll('style="FONT-FAMILY: 宋体"', "")
            //   .replace('<span style="font-family: 宋体; font-size: 19px;">', "")
            //   .replace('<span style="font-family: 宋体; font-size: 14px;">', "")
            //   .replaceAll("</span>", "")
            // item.description =
            //   item.description.length > 30
            //     ? item.description.substr(0, 30) + "..."
            //     : item.description;
          });
        }

        this.doctorListData = res || [];
      });
    },
    godoctor(id) {
      let articleId = id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/doctor/${articleId}`,
      });
      window.open(href, "_self");
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getKsList(this.$route.params.id);
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.ibox {
  min-height: 120px;
}
.ksjs_name {
  cursor: default;
}
.w50 {
  min-width: 50px;
}
</style>
